<template>
    <p :style="typographyStyle">
      {{ title }}
      <slot name="title"></slot>
    </p>
</template>

<script lang="ts">
import { sizeMap } from '@/components/utils'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ required: false, type: String }) readonly title!: string;
  @Prop({ default: 'md', type: String }) readonly size!: 'xs' | 'sm' | 'md' | 'lg' | 'mdl' | 'normal'; // Adjust as per your size options
  @Prop({ default: '400', type: [String, Number] }) readonly weight!: string | number;
  @Prop({ default: 'rgba(4, 4, 16, 0.87)', type: String }) readonly color!: string;

  get typographyStyle(): Record<string, string> {
    const sizeStyles = sizeMap[this.size] || sizeMap.md
    return {
      color: this.color,
      fontFamily: 'Inter, sans-serif',
      fontSize: sizeStyles.fontSize,
      fontWeight: this.weight.toString(),
      lineHeight: sizeStyles.lineHeight,
      letterSpacing: sizeStyles.letterSpacing
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
</style>
